import DirectMessageForm from "./DirectMessageForm";

export default DirectMessageForm;
